import { PARAGRAPH_KEY, HEADING_KEY, LINK_KEY } from '@techchange/pm-specs';

/**
 * Parses nodes between the current text selection and extracts
 * the link mark at the specified mouse position.
 *
 * @param {Object} state     The current editor state.
 * @param {number} mousePos  The position of the mouse click.
 *
 * @returns {Object} The link mark object and its start and end
 * positions in the doc.
 *
 */
const getSelectedLink = (state, mousePos) => {

	const { schema, selection } = state;

	const { from, to } = selection;

	// Node type constants
	const paragraphNodeType = schema.nodes[PARAGRAPH_KEY];
	const headingNodeType = schema.nodes[HEADING_KEY];
	const linkMarkType = schema.marks[LINK_KEY];

	let linkMark, start, end;

	if (!selection.node) {

		state.doc.nodesBetween(from, to, (node, nodePos) => {

			if (node.type === paragraphNodeType || node.type === headingNodeType) {

				// Find the inline node that was clicked
				node.descendants((childNode, childNodePos) => {

					const docOffset = nodePos + 1 + childNodePos;

					const childClicked = mousePos > docOffset &&
						mousePos < (docOffset + childNode.nodeSize);

					if (childClicked) {

						linkMark = childNode.marks.find((mark) => mark.type === linkMarkType);
						start = linkMark && docOffset;
						end = linkMark && (docOffset + childNode.nodeSize);

					}

				});

			}

			// Keep searching if we haven't found link mark yet
			return !linkMark;

		});

	}

	return { linkMark, start, end };

};

export default getSelectedLink;
